module.exports = __webpack_public_path__ + "static/img/search.52406310.png";